import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  CreateChatType,
  LiveChatEndReason,
  LiveChatPlatform,
} from '../../types/enum';
import { HttpErrorResponse } from '@angular/common/http';

export const LiveChatActions = createActionGroup({
  source: 'LiveChat',
  events: {
    'Escalate To Live Chat': props<{
      departmentId: string;
      platform: string;
      aaEligible: boolean;
    }>(),
    'Connect To Live Chat': emptyProps(),
    'Get Create Chat Response': props<{
      response: any;
      createChatType: CreateChatType;
    }>(),
    'Handle Create Chat Success': props<{
      webSocketURL: string;
      chatKey: string;
      chatId: string;
      clientId: string;
      queueApiKey: string;
    }>(),
    'Create Live Chat IFrame': emptyProps(),
    'Update Live Chat Waiting': props<{
      text: string;
      position: number;
      waitTime: number;
    }>(),
    'Set Connection': emptyProps(),
    'Set Chat Id': props<{ value: string }>(),
    'User Cancel Connection': emptyProps(),
    'End Live Chat': props<{ reason: LiveChatEndReason }>(),
    'Close Old Connection Before Transfer': props<{
      reason: LiveChatEndReason;
    }>(),
    'Set End Reason': props<{ reason: LiveChatEndReason }>(),
    'Handle Live Chat Messages': emptyProps(),
    'Reset Operator': emptyProps(),
    'Waiting For An Agent': emptyProps(),
    'Receive Operator Message': props<{
      messageId: string;
      text: string;
      operatorName: string;
      operatorId: string;
    }>(),
    'Receive System Message': props<{
      messageId: string;
      text: string;
    }>(),
    'Assigned To First Operator': emptyProps(),
    'Handle Connection Error': props<{ error: HttpErrorResponse }>(),
    'Set Live Chat State': props<{
      chatId: string;
      chatKey: string;
      clientId: string;
      webSocketURL: string;
      queueApiKey: string;
    }>(),
    'Waiting For Messages': emptyProps(),
    'Create Web Socket Client': props<{
      webSocketURL: string;
    }>(),
    'Reconnect Successfully': emptyProps(),
    'Increment Unread Count': emptyProps(),
    'Add Operator Message': props<{
      messageId: string;
      text: string;
      operatorName: string;
    }>(),
    'Set Safe Send Url': props<{ safeSendUrl: string; messageId: string }>(),
    'Start Agent Assist Session': emptyProps(),
    'Set Agent Assist Session': props<{ isAASessionCreated: boolean }>(),
    'Send Message To Agent Assist': props<{ query: string }>(),
    'On Connection Closed': props<{ reason: LiveChatEndReason }>(),
    'Transfer Between Platforms': props<{ targetPlatform: LiveChatPlatform }>(),
    'Get Department Id': emptyProps(),
    'Set Department Id': props<{ departmentId: string }>(),
    'Set Operator': props<{
      operatorName: string;
      operatorId: string;
    }>(),
  },
});
